import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { useEffect, useMemo } from "react";

import { useEnrichedHouseholds } from "@/api/hooks/useEnrichedHouseholds.ts";
import { useUser } from "@/api/hooks/useUser";

export default function HomePage() {
  const user = useUser();
  const buildings = useEnrichedHouseholds(user);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const shouldShowSFDemo = useMemo(() => {
    const hasSFBuilding = buildings.some((building) => building.buildingId === 37);
    return hasSFBuilding && buildings.some((building) => building.households.some((h) => h.id === 542));
  }, [buildings]);

  useEffect(() => {
    if (shouldShowSFDemo) {
      navigate(`/household/542`);
      return;
    }
    if (buildings.length > 0 && buildings[0].households.length > 0) {
      navigate(`/household/${buildings[0].households[0].id}`);
    }
  }, [buildings, navigate, shouldShowSFDemo]);

  return (
    <main className="flex flex-grow flex-col pt-12 p-4 md:p-12 md:overflow-y-auto scrollbar-thin scrollbar-track-slate-100 scrollbar-thumb-white gap-6">
      {user?.name && (
        <h2 className="font-semibold text-4xl">
          {t("home.welcome")}, {user?.name}!
        </h2>
      )}
      {buildings.map((building) => (
        <div key={building.buildingId}>
          <h2 className="text-xl font-semibold">{building.street}</h2>
          <div className="flex flex-row flex-wrap gap-4 mb-4 justify-between">
            {building.households.map((household) => (
              <div
                key={household.id}
                onClick={() => navigate(`/household/${household.id}`)}
                className="text-gray-700 text-center text-xl font-semibold hover:bg-orange-100 cursor-pointer p-6 bg-white rounded-md min-w-[160px]"
              >
                {household.title}
              </div>
            ))}
            <span className="flex-grow" />
          </div>
        </div>
      ))}
    </main>
  );
}
